export default __webpack_public_path__ + "static/media/spooky_hill_background_s1.810f6a66.jpg";